"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUseless = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var compact_1 = tslib_1.__importDefault(require("lodash/fp/compact"));
var filter_1 = tslib_1.__importDefault(require("lodash/fp/filter"));
var flow_1 = tslib_1.__importDefault(require("lodash/fp/flow"));
var fromPairs_1 = tslib_1.__importDefault(require("lodash/fromPairs"));
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var isObject_1 = tslib_1.__importDefault(require("lodash/isObject"));
var map_1 = tslib_1.__importDefault(require("lodash/fp/map"));
var toPairs_1 = tslib_1.__importDefault(require("lodash/toPairs"));
function isUseless(obj) {
    return isNil_1.default(obj) || (isObject_1.default(obj) && isEmpty_1.default(obj));
}
/**
 * For a given object returns a copy that has all properties that are empty objects or arrays or nil removed.
 * This is applied recursively.
 *
 * @param obj - object to handle
 * @returns always a new instance if obj is not scalar
 */
function removeUseless(obj) {
    var res = obj;
    if (isArray_1.default(obj)) {
        res = flow_1.default(map_1.default(removeUseless), compact_1.default)(obj);
    }
    else if (isObject_1.default(obj)) {
        res = flow_1.default(toPairs_1.default, map_1.default(function (_a) {
            var key = _a[0], value = _a[1];
            return [key, removeUseless(value)];
        }), filter_1.default(function (_a) {
            var _ = _a[0], value = _a[1];
            return !isUseless(value);
        }), fromPairs_1.default)(obj);
    }
    return isUseless(res) ? undefined : res;
}
exports.removeUseless = removeUseless;
//# sourceMappingURL=removeUseless.js.map